import { Group, Highlight } from "@mantine/core";
import { spotlight, Spotlight } from "@mantine/spotlight";
import { generatePath, useNavigate } from "react-router";
import { ROUTES } from "../../../routes";
import type { TQuicksearchVertrag } from "../Quicksearch.types";

function QuicksearchVermarktungsvertrag({
  item,
  highlight = []
}: {
  item: TQuicksearchVertrag;
  highlight?: string[];
}) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(
      generatePath(ROUTES.vermarktung.contract, {
        contractId: item.id.toString()
      })
    );
    spotlight.close();
  };

  return (
    <Group justify="space-between" key={item.name}>
      <Spotlight.Action flex={1} w="auto" onClick={handleClick}>
        <Highlight highlight={highlight}>{item.name}</Highlight>
      </Spotlight.Action>
    </Group>
  );
}

export { QuicksearchVermarktungsvertrag };
